import { TaskListBase } from '@awork/features/task/models/task-list.model.base'

export class TaskListTimeline extends TaskListBase {
  startOn: Date
  endOn: Date
  autoLaneOrder?: number
  laneOrder?: number
  taskIds?: string[]
  entityType: string

  constructor(taskList: Partial<TaskListTimeline> & Pick<TaskListTimeline, 'startOn' | 'endOn'>) {
    const { startOn, endOn, autoLaneOrder, taskIds } = taskList

    super(taskList)

    this.entityType = 'TaskListTimeline'
    this.taskIds = taskIds

    if (startOn) {
      this.startOn = startOn instanceof Date ? startOn : new Date(startOn)
    }

    if (endOn) {
      this.endOn = endOn instanceof Date ? endOn : new Date(endOn)
    }

    if (autoLaneOrder) {
      this.autoLaneOrder = autoLaneOrder
    }
  }
}
